module.exports = __webpack_public_path__ + "static/media/language.070fcbe6.svg";